import React from "react";
import searchIcon from "../../assets/images/search-icon.png";
import { getDisplayTitle } from "./NavbarSearch";

function DesktopNavbarSearch({
  navigate,
  t,
  searchContainerRef,
  query,
  handleSearchChange,
  isSearching,
  showResults,
  searchResults,
  currentLang,
}) {
  return (
    <li>
      <div
        className="relative flex items-center w-full min-w-[100px] text-white"
        ref={searchContainerRef}
      >
        <input
          id="search-query"
          name="searchQuery"
          type="text"
          value={query}
          onChange={handleSearchChange}
          placeholder={t("search")}
          aria-label={t("search")}
          autoComplete="off"
          className="w-[70%] max-w-[200px] h-[30px] rounded-md bg-[#2C2C2C] px-3 py-1 pr-10 text-sm text-white transition-[width] duration-300 focus:outline-none"
        />
        <img
          src={searchIcon}
          alt="Search Icon"
          className="absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 cursor-pointer"
        />
        {isSearching && (
          <span className="absolute right-10 top-1/2 -translate-y-1/2 text-sm text-white">
            ⏳
          </span>
        )}
        {showResults && (
          <div className="search-results absolute left-0 top-full mt-[5px] w-full min-h-[50px] max-h-[300px] bg-white border border-gray-300 rounded-md shadow-md overflow-y-auto z-50 opacity-100 transition-opacity duration-300 flex flex-col items-center">
            {searchResults.length > 0 ? (
              searchResults.map((book) => {
                const displayTitle = getDisplayTitle(book, currentLang);
                return (
                  <div
                    key={book.id}
                    onClick={() => navigate(`/book/${book.bookUrl}`)}
                    className="flex w-full items-center gap-3 border-b border-gray-200 px-4 py-2 hover:bg-gray-200 cursor-pointer"
                  >
                    <img
                      src={book.imageUrl}
                      alt={displayTitle}
                      className="w-10 h-10 rounded-md object-cover"
                    />
                    <div className="flex flex-col">
                      <span className="font-bold text-[#333]">
                        {displayTitle}
                      </span>
                      {book.author && (
                        <span className="text-sm text-gray-600">
                          {book.author}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="flex justify-center items-center w-full h-full px-4 py-2 text-gray-600 text-center">
                {t("noResults")}
              </div>
            )}
            <div className="px-4 py-2 border-t border-gray-300 text-center">
              <button
                className="text-blue-600 font-medium hover:underline w-full"
                onClick={() => navigate("/catalog")}
              >
                {t("advancedSearch")}
              </button>
            </div>
          </div>
        )}
      </div>
    </li>
  );
}

export default DesktopNavbarSearch;
